export default {
  'nav.home': '首页',
  'nav.categories': '分类浏览',
  'nav.about': '关于我们',
  'nav.contact': '联系我们',
  'footer.brand_desc': '91豆花 - 传承千年豆花文化，以匠心工艺呈现最地道的豆花美食体验。从经典甜咸到创新融合，每一碗都是对传统美食的致敬。',
  'footer.quick_links': '快速链接',
  'footer.categories': '豆花分类',
  'footer.contact_us': '联系我们',
  'footer.phone': '电话',
  'footer.email': '邮箱',
  'footer.address': '地址',
  'footer.copyright': '© 2024 91豆花 版权所有',
  'footer.newsletter': '订阅我们的 newsletter',
  'footer.newsletter_placeholder': '输入您的邮箱地址',
  'footer.newsletter_btn': '订阅',
  'hero.title': '一碗豆花，千年传承',
  'hero.subtitle': '91豆花以匠心手艺，为您呈现最正宗的传统豆花美食。从经典甜豆花到创意咸豆花，每一口都是对味蕾的极致宠爱。',
  'hero.cta_explore': '探索食谱',
  'hero.cta_franchise': '加盟合作',
  'features.title': '为什么选择91豆花',
  'features.subtitle': '从原料到工艺，每一个环节都倾注我们对品质的执着追求',
  'recipes.title': '热门豆花食谱',
  'recipes.subtitle': '精选最受欢迎的豆花制作方法，从经典到创意，应有尽有',
  'recipes.view_all': '查看全部食谱',
  'recipes.difficulty': '难度',
  'recipes.time': '耗时',
  'recipes.servings': '份量',
  'recipes.read_more': '查看详情',
  'culture.title': '豆花文化',
  'culture.subtitle': '探索豆花背后的千年文化传承与地域饮食智慧',
  'testimonials.title': '食客口碑',
  'testimonials.subtitle': '来自全国各地的豆花爱好者真实评价',
  'franchise.title': '共创甜蜜事业',
  'franchise.subtitle': '加入91豆花大家庭，开启您的餐饮创业之旅',
  'franchise.cta': '立即咨询加盟',
  'faq.title': '常见问题',
  'faq.subtitle': '关于豆花和91豆花的常见疑问解答',
  'newsletter.title': '获取最新食谱和优惠',
  'newsletter.subtitle': '订阅我们的 newsletter，第一时间获取新品发布和独家优惠信息',
  'breadcrumb.home': '首页',
  'breadcrumb.category': '分类',
  'category.all': '全部',
  'category.title': '探索豆花美味',
  'category.subtitle': '按分类浏览我们的豆花食谱',
  'article.ingredients': '食材清单',
  'article.steps': '制作步骤',
  'article.tips': '小贴士',
  'article.related': '相关推荐',
  'article.back': '返回列表',
  'about.story_title': '我们的故事',
  'about.mission_title': '品牌使命',
  'about.values_title': '核心价值观',
  'about.contact_title': '联系我们',
  'about.form_name': '您的姓名',
  'about.form_email': '您的邮箱',
  'about.form_phone': '您的电话',
  'about.form_message': '留言内容',
  'about.form_submit': '发送消息',
  'about.form_success': '消息已发送成功，我们会尽快与您联系！',
  'about.form_error': '发送失败，请稍后重试。',
};